import {
  googleAccounts,
  isLoadingAccounts,
  accountError,
  selectedAccountId,
} from '../state'
import { getAccounts } from '../../../actions/google/methods/get-accounts'
import axios from '@/plugins/axiosInstance'
import { socialMedia } from '@/networking/urlManager'
import { useAssetStore } from '@/stores/asset'

/**
 * Loads Google accounts for the integration
 * @returns {Promise<Array>} List of Google accounts
 */
export const loadGoogleAccounts = async () => {
  isLoadingAccounts.value = true
  accountError.value = null
  selectedAccountId.value = null // Reset selected ID on each load

  try {
    // Get accounts
    const accounts = await getAccounts()
    googleAccounts.value = accounts

    return accounts
  } catch (error) {
    accountError.value = 'Google hesabınıza erişilemedi. Lütfen tekrar deneyin.'
    googleAccounts.value = []
    throw error
  } finally {
    isLoadingAccounts.value = false
  }
}
